var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___RGUzcV",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___RGUzcV",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___RGUzcV",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___RGUzcV",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___RGUzcV",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___RGUzcV",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___RGUzcV",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___RGUzcV",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___RGUzcV",
};

module.exports = exports;
